/*
 * Teng Tools USA — printable chart for an email, on the blog chart pages (owner, 2026-10-14).
 * Source: scripts/teng/store-sync/chart-signup/teng-chart-signup.js. Pushed to the live theme by
 * push-chart-signup-assets.mjs, which writes the CHARTS list below from backend chart-pages.js (the one list).
 * Plan: memory/plans/teng-blog-chart-signup-plan.md.
 *
 * What a reader sees: an inline "print this chart" block (every device) and, on desktop only, a small corner
 * card after half the article. Never a full-screen overlay: these pages carry most of the store's Google search
 * traffic, and a mobile interstitial on a search landing is demoted.
 *
 * WHERE THE BLOCK GOES, AND WHY: right after the chart table when that spot is below the screen at the moment
 * we insert, otherwise at the end of the article. Inserting into what the reader is looking at moves the text
 * under their thumb (layout shift, a Core Web Vitals signal on our biggest search pages). Off-screen it moves
 * nothing they can see.
 *
 * WHO SEES IT: US and Canada, from Shopify's own country detection. If detection fails it shows anyway (fails
 * OPEN): a free PDF shown to the wrong country costs nothing, a block that silently never shows costs the whole
 * point. tengBlogChartSignupFlow alarms when detection stops answering. ?chart_signup=preview skips the
 * country check, for testing from outside North America.
 */
(function () {
  'use strict';

  var API = 'https://simplyfactura-api.fly.dev/api/teng/conquest';
  var COUNTRIES = { US: true, CA: true };
  /*@@CHARTS@@*/var CHARTS = [{"key":"wrench-m2s","handle":"metric-to-standard-wrench-conversion-chart"},{"key":"wrench-s2m","handle":"standard-to-metric-wrench-conversion-chart"},{"key":"sae-metric","handle":"sae-to-metric-conversion-chart"},{"key":"tire-tread","handle":"tire-tread-depth-conversion-32-inch-mm"},{"key":"fractions-mm","handle":"fractions-to-decimals-to-inches-to-mm-conversion-chart"}];/*@@END@@*/

  // English article paths only: the /es/ and /fr/ copies are read almost entirely outside North America.
  var m = location.pathname.match(/^\/blogs\/news\/([a-z0-9-]+)\/?$/);
  if (!m) return;
  var chart = null;
  for (var i = 0; i < CHARTS.length; i++) if (CHARTS[i].handle === m[1]) chart = CHARTS[i];
  if (!chart) return;
  var body = document.querySelector('.blog-post-content');
  if (!body) return;

  var SOURCE = 'chart-' + chart.key;
  var DONE_KEY = 'tengChartPdf:' + chart.key;
  var SLIDE_KEY = 'tengChartSlideClosed';
  var preview = /[?&]chart_signup=preview\b/.test(location.search);

  function get(k) { try { return localStorage.getItem(k); } catch { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch { /* storage or beacon blocked: never break the page */ } }
  function visitId() {
    try {
      var v = sessionStorage.getItem('tngVisit');
      if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem('tngVisit', v); }
      return v;
    } catch { return null; }
  }
  // Once per visit per event; sendBeacon survives the tab closing. Never blocks, never shows an error.
  var beaconed = {};
  function beacon(ev) {
    if (beaconed[ev]) return;
    beaconed[ev] = true;
    try {
      var payload = JSON.stringify({ event: ev, source: SOURCE, visitId: visitId() });
      if (navigator.sendBeacon) navigator.sendBeacon(API + '/event', new Blob([payload], { type: 'application/json' }));
      else fetch(API + '/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(function () {});
    } catch { /* storage or beacon blocked: never break the page */ }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  // Only ever our own Shopify Files copy: the url comes from our API or this browser's storage, never the page.
  var PDF_URL = /^https:\/\/cdn\.shopify\.com\/[^\s"'<>]+\.pdf(\?[^\s"'<>]*)?$/;

  function downloadLink(url) {
    var a = el('a', 'teng-chart-signup__download', 'Download the PDF');
    a.href = url; a.target = '_blank'; a.rel = 'noopener';
    return a;
  }

  // One form, used inline and in the corner card. Every instance learns when any of them succeeds.
  var forms = [];
  function done(url) {
    set(DONE_KEY, url);
    forms.forEach(function (f) { f.showDone(url); });
  }

  function buildForm(idSuffix) {
    var wrap = el('div', 'teng-chart-signup__body');
    var form = el('form', 'teng-chart-signup__form');
    form.noValidate = true;
    var label = el('label', 'teng-chart-signup__label', 'Email');
    var inputId = 'teng-chart-email-' + idSuffix;
    label.htmlFor = inputId;
    var input = el('input', 'teng-chart-signup__input');
    input.type = 'email'; input.id = inputId; input.name = 'email'; input.autocomplete = 'email';
    input.required = true; input.placeholder = 'you@yourshop.com';
    var btn = el('button', 'teng-chart-signup__button', 'Email me the chart');
    btn.type = 'submit';
    var row = el('div', 'teng-chart-signup__row');
    row.appendChild(input); row.appendChild(btn);
    var consent = el('p', 'teng-chart-signup__consent',
      'We will email you this chart and occasional Teng Tools shop notes. Unsubscribe any time.');
    var msg = el('p', 'teng-chart-signup__msg');
    msg.setAttribute('aria-live', 'polite');
    form.appendChild(label); form.appendChild(row); form.appendChild(consent); form.appendChild(msg);
    wrap.appendChild(form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; input.focus(); return; }
      msg.textContent = '';
      btn.disabled = true; btn.textContent = 'One moment…';
      fetch(API + '/chart', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, chart: chart.key, visitId: visitId() }),
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.body || !res.body.pdfUrl) throw new Error((res.body && res.body.error) || 'failed');
          done(res.body.pdfUrl);
        })
        .catch(function (err) {
          btn.disabled = false; btn.textContent = 'Email me the chart';
          msg.textContent = err && err.message && err.message !== 'failed' && err.message.length < 140
            ? err.message : 'That did not go through. Please try again in a moment.';
        });
    });

    var api = {
      node: wrap,
      showDone: function (url) {
        if (!PDF_URL.test(url)) return;
        while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
        var p = el('p', 'teng-chart-signup__ok', 'Sent. It is in your inbox too. ');
        p.appendChild(downloadLink(url));
        wrap.appendChild(p);
      },
    };
    forms.push(api);
    return api;
  }

  function inlineBlock() {
    var box = el('aside', 'teng-chart-signup');
    box.setAttribute('aria-label', 'Printable chart');
    box.appendChild(el('p', 'teng-chart-signup__eyebrow', 'Free printable'));
    box.appendChild(el('h2', 'teng-chart-signup__title', 'Print this chart for the shop'));
    box.appendChild(el('p', 'teng-chart-signup__lede', 'A one-page PDF of this chart, sized for US Letter, sent to your email.'));
    var f = buildForm('inline');
    box.appendChild(f.node);
    var stored = get(DONE_KEY);
    if (stored) f.showDone(stored);
    return box;
  }

  function placeInline(box) {
    var anchor = body.querySelector('table');
    var spot = anchor ? anchor.getBoundingClientRect().bottom : -1;
    if (anchor && spot > window.innerHeight) anchor.insertAdjacentElement('afterend', box);
    else body.appendChild(box);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { beacon('shown'); io.disconnect(); }
      }, { threshold: 0.5 });
      io.observe(box);
    }
  }

  function slideIn(inlineBox) {
    if (!window.matchMedia || !window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) return;
    var closedAt = Number(get(SLIDE_KEY) || 0);
    if (closedAt && Date.now() - closedAt < 30 * 864e5) return;
    var shown = false;
    function onScroll() {
      if (shown || get(DONE_KEY)) return;
      var doc = document.documentElement;
      var progress = (window.scrollY + window.innerHeight) / Math.max(1, doc.scrollHeight);
      if (progress < 0.5) return;
      var r = inlineBox.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return; // the inline block is already on screen
      shown = true;
      window.removeEventListener('scroll', onScroll);
      var card = el('aside', 'teng-chart-slide');
      card.setAttribute('aria-label', 'Printable chart');
      var close = el('button', 'teng-chart-slide__close', '×');
      close.type = 'button'; close.setAttribute('aria-label', 'Close');
      close.addEventListener('click', function () {
        card.remove(); set(SLIDE_KEY, String(Date.now())); beacon('dismissed');
      });
      card.appendChild(close);
      card.appendChild(el('p', 'teng-chart-slide__title', 'Print this chart for the shop'));
      card.appendChild(buildForm('slide').node);
      document.body.appendChild(card);
      beacon('shown');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function start() {
    var box = inlineBlock();
    placeInline(box);
    slideIn(box);
  }

  if (preview) { start(); return; }
  var cached = null;
  try { cached = sessionStorage.getItem('tngCountry'); } catch { /* storage or beacon blocked: never break the page */ }
  if (cached) { if (cached === '?' || COUNTRIES[cached]) start(); return; }
  fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      try { sessionStorage.setItem('tngCountry', c || '?'); } catch { /* storage or beacon blocked: never break the page */ }
      if (!c || COUNTRIES[c]) start();
    })
    .catch(function () { start(); });
})();
